import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {db} from '../../Base';
import { storage } from '../../Base';
import './Blocks.css';
import {collection, getDocs, query, orderBy} from 'firebase/firestore';


function Blocks() {
 
  const [blocks, setBlocks] = useState([]);

  const usersCollectionRef = collection(db, "blocks");
 
  const q = query(usersCollectionRef, orderBy("name"));

  const getData = async () => {
      const data = await getDocs(q, usersCollectionRef)
      setBlocks(data.docs.map((doc) => ({...doc.data(), id:doc.id})));
  }


  useEffect(() => {
      getData();
  }, []);


  return (
    <Contain>
      <br/>
      <br/>
      
      <StatsContain>
      <h1>TOP 5 BLOCKS</h1>
      {blocks.map(({id, name, imgurl, blocks, no}) => (
          <Div1 key={id}>
            {no}
            <Img2 src={imgurl} alt="image"/>
            <h2> {name}</h2>
            <Div2>
              {blocks}
            </Div2>
          </Div1>
              ))}
      </StatsContain>
      <br/>
      <br/>
      <br/>
    </Contain>
  )
}

export default Blocks


const Contain = styled.div`
    width: 100%;
    color: white;
    font-size: medium;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: white;
    align-items: center;
   
    a{
      color: white;     
    }
    h2{
      width: 30%;
      color: white;
      display: flex;
      flex-wrap: wrap;
      @media screen and (max-width: 850px) {
        font-size: 15px;

      }
    }
    h1{
      color: #993333;
    }
`


const Div1 = styled.div`
        display: flex;
        width: 98%;
        background-color: #0B3F88;
        justify-content: space-around;
        align-items: center;
        border-width: -3px;
        border-style: groove;
        border-color: whitesmoke;
        padding-top: 7px;
        padding-bottom:7px;
`

const Div2 = styled.div`
width: 25%;
display: flex;
justify-content: space-around;
background-color: white;
border-radius: 5px;
color: #0B3F88;
font-weight: bold;
`

const Img2 = styled.img`
height:70px;
width: 70px;
border-radius: 50%;

@media screen and (max-width: 850px){
  height: 40px;
  width: 40px;
}
`

const StatsContain = styled.div`
width: 90%;
display: flex;
flex-wrap: wrap;

`